function isInViewport(el)
{
  var rect = el.getBoundingClientRect();

  return (
      rect.bottom >= 0 && 
      rect.right >= 0 && 

      rect.top <= (
      window.innerHeight || 
      document.documentElement.clientHeight) && 

      rect.left <= (
      window.innerWidth || 
      document.documentElement.clientWidth)
   );
}

function lazyLoad()
{
    var lazy = document.getElementsByClassName('lazy');

    for(var i=0; i<lazy.length; i++)
    {
        if(isInViewport(lazy[i]))
        {
          var __style = lazy[i].getAttribute('data-style');
          if(__style != null && __style != "" && __style.indexOf('background-image') >= 0 && /background-image([\(a-zA-Z0-9\.-=_:\/\?\)])/.test(__style))
          {
            lazy[i].setAttribute('style', __style);
          }
          else lazy[i].src = lazy[i].getAttribute('data-src');
        }
    }
 }
